import { useSelf } from 'App/components/hooks/appHooks';
import { useFeatureAvailable, useSoftDeployAccess } from 'App/components/hooks';
import { useAssistantPermissions } from 'App/components/hooks/useAssistantPermissions';
import { Feature } from 'Store/actions/FeatureHelperActions';

// Single source of truth for who may use the floating chat. Shared by the sidebar button, the
// global Cmd/Ctrl+U shortcut and the window itself so the gates can't drift. Mirrors the AI
// Workspace access rule (license-or-soft-deploy + per-user canAccessWorkspace). The server-side
// aiWorkspaceGuard remains the real boundary.
export function useFloatingChatAccess(): boolean {
	const self = useSelf();
	const hasAiAssistant = useFeatureAvailable(Feature.AI_ASSISTANT);
	const hasAssistantSoftDeploy = useSoftDeployAccess('AI_ASSISTANT');
	const assistantPerms = useAssistantPermissions();
	const canAccessWorkspace = self?.administrator || assistantPerms?.canAccessWorkspace === true;
	return (hasAiAssistant || hasAssistantSoftDeploy) && canAccessWorkspace;
}
